"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Disposable = exports.combineDisposers = exports.Disposer = void 0;
const tslib_1 = require("tslib");
const logger_1 = tslib_1.__importDefault(require("../logger"));
class Disposer {
    constructor(loggerName = null) {
        this._disposers = [];
        this._map = new Map();
        this._loggerName = null;
        this._loggerName = loggerName;
    }
    setLoggerName(loggerName) {
        this._loggerName = loggerName;
        return this;
    }
    add(d, id) {
        if (!d) {
            return;
        }
        const dd = typeof d !== 'function'
            ? (() => d.dispose ? d.dispose() : null)
            : d;
        this._disposers.push(dd);
        if (id) {
            // dispose previous identified disposer
            if (this._map.has(id)) {
                this.execute(id);
            }
            this._map.set(id, dd);
        }
    }
    execute(id) {
        const d = this._map.get(id);
        if (!d) {
            return;
        }
        this._map.delete(id);
        const i = this._disposers.indexOf(d);
        if (i >= 0) {
            this._disposers.splice(i, 1);
        }
        d();
    }
    dispose(log = false) {
        if (log) {
            logger_1.default.log(`[Disposer:${this._loggerName || '<unknown>'}] Disposing ${this._disposers.length} items including named ones:`, Array.from(this._map.entries()).map(e => e[0]));
        }
        const copy = this._disposers.slice().reverse();
        this._disposers.length = 0;
        this._map.clear();
        // this should separate side effects
        copy.forEach(d => d());
    }
}
exports.Disposer = Disposer;
function combineDisposers(...items) {
    return () => items.forEach(i => i());
}
exports.combineDisposers = combineDisposers;
class Disposable {
    constructor(loggerName = null) {
        this._isDisposed = false;
        this.dispose = () => {
            this._isDisposed = true;
            this.disposer.dispose();
        };
        this.disposer = new Disposer(loggerName);
    }
}
exports.Disposable = Disposable;
//# sourceMappingURL=disposer.js.map